import React from "react";
import ReactDOM from 'react-dom';
import {Button, Icon, Input} from 'antd';
import './ChatDialog.css';

class ChatDialog extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            chatText: '',
        };
    }

    emitEmpty = () => {
        this.chatTextInput.focus();
        this.setState({chatText: ''});
    };

    onChangeChatInput = (e) => {
        this.setState({chatText: e.target.value});
    };

    sendInput = () => {
        if(this.state.chatText && this.state.chatText.trim().length > 0) {
            this.props.send(this.state.chatText);
        }
        this.setState({chatText: ''});
    };

    scrollToBottom = () => {
        const node = ReactDOM.findDOMNode(this.messagesEnd);
        node.scrollIntoView({ behavior: "smooth" });
    };

    componentDidMount() {
        this.scrollToBottom();
    }

    componentDidUpdate() {
        this.scrollToBottom();
    }

    render() {
        const {chatText} = this.state;
        const suffix = chatText ? <Icon type="close-circle" onClick={this.emitEmpty}/> : null;


        return (
            <div style={{display: 'flex', flexFlow: 'column', flex: 1}}>
                <div style={{flex: 1, display: 'flex', flexFlow: 'column', overflow: 'auto'}}>
                    {
                        this.props.messages.map(message =>
                            <div key={message.id}
                                 className={`message-wrapper ${message.self ? 'message-wrapper-self' : 'message-wrapper-other'}`}>
                                <div className="label">{message.label}</div>
                                <div
                                    className={`message ${message.self ? 'message-self' : 'message-other'}`}> {message.text}</div>
                            </div>
                        )
                    }
                    <div ref={(el) => { this.messagesEnd = el; }}></div>

                </div>

                <div style={{display: 'flex', padding: 20, background: 'white', borderTop: '1px solid grey'}}>
                    <Input
                        placeholder="Enter message"
                        prefix={<Icon type="user"/>}
                        suffix={suffix}
                        value={chatText}
                        onChange={this.onChangeChatInput}
                        onPressEnter={this.sendInput}
                        ref={node => this.chatTextInput = node}
                    />
                    <Button style={{marginLeft: 20}} onClick={this.sendInput}>Send</Button>
                </div>
            </div>
        )
    }
}

export default ChatDialog;



// WEBPACK FOOTER //
// ./src/components/dialog/ChatDialog.js